import React from 'react';
import styled from 'styled-components';
import Loader from '@rsos/components/capstone/Loader';
import Box from '@rsos/components/capstone/base/Box';

const AppLoading = () => {
  return (
    <LoaderContainer>
      <Loader />
    </LoaderContainer>
  );
};
export default AppLoading;

const LoaderContainer = styled(Box).attrs({
  height: '100%',
  align: 'center',
  justify: 'center',
})``;
